var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('collapsable-card',{attrs:{"title":_vm.$t('app.general.title.fans_outputs'),"icon":"$motion","draggable":true,"layout-path":"dashboard.outputs-card","menu-breakpoint":"lg"}},[_c('outputs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }